import gql from "graphql-tag";

export const GET_CITIES = gql`
  query Cities($where: CountyFilter) {
    countyCollection(limit: 1, where: $where) {
      items {
        county
        citiesCollection {
          items {
            city
          }
        }
        linkedFrom {
          stateCollection(limit: 1) {
            items {
              state
            }
          }
        }
      }
    }
  }
`;

export const GET_COUNTIES = gql`
  query Counties($where: StateFilter) {
    stateCollection(limit: 1, where: $where) {
      items {
        state
        countiesCollection {
          items {
            county
          }
        }
      }
    }
  }
`;

export const GET_LOCAL_JOBS_PAGE = gql`
  query PalJobsPage($where: PalJobsPageFilter) {
    palJobsPageCollection(where: $where) {
      items {
        pageName
        metaTitle
        metaDescription
        metaImage {
          url
        }
        getStartedHeading
        headerHeading
        headerSubheading
        headerImage {
          url
        }
        contentCopy
        contentHeading
      }
    }
  }
`;

export const GET_PAL_JOB_INFORMATION = gql`
  query PalJob {
    palJobCollection(where: { isVirtual: false }) {
      items {
        metaTitle
        metaDescription
        metaImage {
          url
        }
        metaKeywords
        getStartedHeading
        headerHeading
        jobDescription {
          json
        }
        jobPostSchema {
          title
          description
          datePosted
          validThrough
          educationRequirements
          employmentType
          experienceRequirements
          qualifications
          responsibilities
          industry
          jobBenefits
          skills
          organizationName
          organizationSameAs
          organizationLogo
          salaryMinimum
          salaryMaximum
          salaryUnitText
          occupationalCategory
        }
        headerImage {
          url
        }
        headerSubheading
        contentCopy
        contentHeading
      }
    }
  }
`;

export const GET_STATES = gql`
  query States {
    stateCollection {
      items {
        state
      }
    }
  }
`;
